export default __webpack_public_path__ + "static/media/tunnel_route.fce3fc3f.jpg";